// useCharacterHandlers.js
import { useState } from 'react';
import useAICharactersConfig from './useAICharactersConfig';

export function useCharacterHandlers() {
  const [editingConfig, setEditingConfig] = useState(null);
  const [showEditConfigModal, setShowEditConfigModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [aiCharactersConfig, 
    saveEditedCharacterConfig, 
         deleteCharacterConfig, 
         getNewDefaultAICharacterConfig, 
         handleResetToDefaults, 
         isConfig, 
         handleImportNewCharactersConfig, 
         characterNameExists,
         getNewDefaultAICharacterName,
        loadConfig,
      isLoading] = useAICharactersConfig();

  const handleDeleteCharacter = (characterName) => {
    deleteCharacterConfig(characterName);
    setShowEditConfigModal(false);
  };

  const handleSaveEditedCharacter = (updatedConfig) => {
    saveEditedCharacterConfig(editingConfig, updatedConfig);
    setShowEditConfigModal(false);
  };

  const handleAddNewCharacter = (newConfig) => {
    const newCharacterConfig = getNewDefaultAICharacterConfig();
    if (isConfig(newConfig)) {
      const newName = getNewDefaultAICharacterName(newConfig.name);
      newCharacterConfig.name = newName;
      newCharacterConfig.role = newConfig.role;
      newCharacterConfig.systemMessage = newConfig.systemMessage;
      newCharacterConfig.assistantMessage = newConfig.assistantMessage;
    }
    setEditingConfig(newCharacterConfig);
    setShowEditConfigModal(true);
  };

  return {
    aiCharactersConfig,
    editingConfig,
    setEditingConfig,
    showEditConfigModal,
    showConfirmationModal,
    handleDeleteCharacter,
    handleSaveEditedCharacter,
    handleAddNewCharacter,
    setShowEditConfigModal,
    setShowConfirmationModal,
    handleResetToDefaults,
    handleImportNewCharactersConfig,
    characterNameExists,
    loadConfig,
    isLoading
  };
}
